import PropTypes from 'prop-types'
import './FormControlsGroup.css'

const FormControlsGroup = ({children, className, title}) => {
    const classNames = `form-controls-group ${className ?? ''}`

    return (
        <div className={classNames}>
            {title}
            <div className='form-controls'>
                {children}
            </div>
        </div>
    )
}

FormControlsGroup.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string
}

export default FormControlsGroup
